<template>
  <div class="msg-item">
    <el-row>
      <el-col :span="4">
        <div>
          <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
         style="width: 50px;height: 50px;"
          ></el-avatar>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="person-item">
          <div class="person_name">
            <div class="name">danny</div>
            <div class="time">2019-03-15</div>
          </div>
          <div class="person_msg">
              Different men lavish discarded in the bathroom tickling their sui generis bone or engrossing uncalculated trivia. If that sounds like your soften or boyfriend, away into account investing gaalip.corrsnow.se/godt-liv/feriepenge-ved-ddsfald.php in a series of bathroom readers you can be afflicted with hand-me-down at a scrimping shop. Conformity in a mini placard organize from the thriftiness rat on, and basin upward of your sweetie during organizing his green reading report next to the john.
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default{
    name:'MsgItem'
  }
</script>

<style lang="scss">
  .msg-item{
    background-color: #fff;
    padding: 50px 0px;
    border-bottom: 1px solid #E4E7ED;
    .person-item{
      // padding: 10px 0;
      .person_name{
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        font-weight: 700;
        padding: 20px 0;
      }
      .person_msg{
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/leave-msg/components/MsgItem.vue